import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'app-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.css']
})
export class ProgressSpinnerComponent implements OnInit {
    @ViewChild('progressSpinnerRef', {static: true}) private progressSpinnerRef!: TemplateRef<any>;
    constructor() {
    }

    ngOnInit() {
    }
}
